// Mock data for HRMQore website

export const features = [
  {
    id: 1,
    title: "Leave Management",
    description: "Streamline leave requests, approvals, and tracking with automated workflows and real-time balance updates.",
    icon: "Calendar"
  },
  {
    id: 2,
    title: "Attendance Management",
    description: "Track employee attendance with biometric integration, geofencing, and automated timesheet generation.",
    icon: "Clock"
  },
  {
    id: 3,
    title: "Instant Messaging",
    description: "Real-time team communication with secure channels, file sharing, and integrated notifications.",
    icon: "MessageSquare"
  },
  {
    id: 4,
    title: "Approval Workflows",
    description: "Multi-level maker-checker approvals for expenses, leaves, and requisitions with audit trails.",
    icon: "CheckCircle"
  },
  {
    id: 5,
    title: "Global Payroll",
    description: "Multi-currency payroll processing with automated tax compliance, instant payslips, and bank integrations.",
    icon: "DollarSign"
  },
  {
    id: 6,
    title: "In-App Wallet System",
    description: "Digital expense wallets with instant funding, approval workflows, and real-time spend analytics.",
    icon: "Wallet"
  },
  {
    id: 7,
    title: "Recruitment Module",
    description: "End-to-end recruitment management from job posting to onboarding with ATS integration.",
    icon: "Users"
  },
  {
    id: 8,
    title: "Performance Tracking",
    description: "Continuous performance reviews, goal setting, and 360-degree feedback mechanisms.",
    icon: "TrendingUp"
  }
];

export const testimonials = [
  {
    id: 2,
    name: "Akinola Arigbede",
    position: "HR Manager",
    company: "Mecure",
    content: "Managing leave requests and approvals used to be a nightmare. Now everything is automated and transparent. Our team satisfaction scores have increased by 40%.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1531384441138-2736e62e0919?w=150&h=150&fit=crop",
    type: "hr"
  },
  {
    id: 3,
    name: "Emilia",
    position: "Employee",
    company: "Tro-vest",
    content: "The Advance and wallet feature is smooth and very helpful. During a period when travel ticket prices increased, the salary advance feature helped me cover my expenses and travel without stress.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop",
    type: "employee"
  },
  {
    id: 1,
    name: "Amaka Obiji",
    position: "GHCM",
    company: "Tro-vest",
    content: "HRMQore has revolutionized how we manage our team's renumeration. Payroll processing has been seamless allowing us to focus on other strategic initiatives that truly matter.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop",
    type: "hr"
  },
  
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: "49",
    period: "per month",
    description: "Perfect for small teams getting started",
    features: [
      "Up to 50 employees",
      "Leave Management",
      "Attendance Tracking",
      "Basic Reporting",
      "Email Support",
      "Mobile App Access"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Professional",
    price: "149",
    period: "per month",
    description: "For growing businesses with advanced needs",
    features: [
      "Up to 200 employees",
      "All Starter features",
      "Payroll Management",
      "Recruitment Module",
      "Approval Workflows",
      "Advanced Analytics",
      "Priority Support",
      "API Access"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    period: "contact us",
    description: "Tailored solutions for large organizations",
    features: [
      "Unlimited employees",
      "All Professional features",
      "Multi-Currency Payroll",
      "Wallet System",
      "Custom Integrations",
      "Dedicated Account Manager",
      "24/7 Phone Support",
      "SLA Guarantees",
      "Custom Training"
    ],
    popular: false
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Future of HR: AI and Automation in 2025",
    excerpt: "Discover how artificial intelligence is transforming human resources management and what it means for your organization.",
    category: "Product",
    date: "2025-01-15",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=400&fit=crop",
    author: "Oghenetega John"
  },
  {
    id: 2,
    title: "10 Best Practices for Remote Team Management",
    excerpt: "Learn proven strategies to effectively manage and engage remote teams in today's hybrid work environment.",
    category: "HR",
    date: "2025-01-10",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&h=400&fit=crop",
    author: "Oghenetega John"
  },
  {
    id: 3,
    title: "Payroll Compliance: Navigating Global Regulations",
    excerpt: "A comprehensive guide to understanding and maintaining payroll compliance across different countries and regions.",
    category: "HR",
    date: "2025-01-05",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&h=400&fit=crop",
    author: "Oghenetega John"
  },
  {
    id: 4,
    title: "Employee Engagement: Why It Matters More Than Ever",
    excerpt: "Explore the connection between employee engagement, productivity, and retention in modern workplaces.",
    category: "HR",
    date: "2024-12-28",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=400&fit=crop",
    author: "Oghenetega John"
  },
  {
    id: 5,
    title: "Streamlining Recruitment: From ATS to Onboarding",
    excerpt: "Optimize your hiring process with integrated recruitment tools and automated workflows.",
    category: "HR",
    date: "2024-12-20",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&h=400&fit=crop",
    author: "Oghenetega John"
  },
  {
    id: 6,
    title: "HRMQore Secures Series A Funding to Expand Operations",
    excerpt: "We are excited to announce a significant milestone in our journey to transform HR management across Africa.",
    category: "Press",
    date: "2024-12-15",
    readTime: "3 min read",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=400&fit=crop",
    author: "HRMQore Team"
  },
  {
    id: 7,
    title: "Building a Strong Employer Brand in 2025",
    excerpt: "Learn how to attract top talent by developing a compelling employer brand that resonates with candidates.",
    category: "HR",
    date: "2024-12-10",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&h=400&fit=crop",
    author: "Oghenetega John"
  },
  {
    id: 8,
    title: "HRMQore Product Update: New Analytics Dashboard",
    excerpt: "Announcing our latest product release featuring powerful analytics and reporting capabilities.",
    category: "Product",
    date: "2024-12-05",
    readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=400&fit=crop",
    author: "HRMQore Team"
  },
  {
    id: 9,
    title: "Managing Performance Reviews Effectively",
    excerpt: "Tips and strategies for conducting meaningful performance reviews that drive employee growth.",
    category: "HR",
    date: "2024-12-01",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800&h=400&fit=crop",
    author: "Oghenetega John"
  }
];

export const companyValues = [
  {
    id: 1,
    title: "Innovation First",
    description: "We constantly push boundaries to deliver cutting-edge HR solutions that transform how businesses operate.",
    icon: "Lightbulb"
  },
  {
    id: 2,
    title: "People-Centric",
    description: "Your employees are at the heart of everything we do. We build tools that empower and engage your workforce.",
    icon: "Heart"
  },
  {
    id: 3,
    title: "Trust & Security",
    description: "Bank-grade security and data protection ensure your sensitive HR information is always safe and compliant.",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Global Vision",
    description: "Supporting businesses worldwide with multi-currency, multi-language, and multi-region capabilities.",
    icon: "Globe"
  }
];

export const stats = [
  {
    id: 1,
    value: "10,000+",
    label: "Active Users"
  },
  {
    id: 2,
    value: "50+",
    label: "Countries Served"
  },
  {
    id: 3,
    value: "98%",
    label: "Customer Satisfaction"
  },
  {
    id: 4,
    value: "24/7",
    label: "Support Available"
  }
];